import {getIssuePhotoSrc, Issue} from "../api/issue.ts";
import {FC} from "react";
import Panel from "../atoms/Panel.tsx";
import {Column, Row} from "../atoms/Layout.tsx";
import DateBadge from "../molecules/DateBadge.tsx";
import {Text} from "../style/typography.tsx";
import {LocationIcon, SubtitleIcon, WarningIcon} from "../atoms/Icon";
import ImageCarousel from "../molecules/ImageCarousel.tsx";
import IssueCompleteButton from "../organisms/IssueCompleteButton.tsx";

interface Props {
    issue: Issue
}

const IssueDetails: FC<Props> = ({ issue }) => {
    const photoSources = issue.photos.map(photo => getIssuePhotoSrc(issue.id, photo.id));

    return <Panel>
        <Column gap="32">
            <Row gap="16">
                <DateBadge date={issue.createdAt} />
            </Row>
            <Column gap="12">
                <Row gap="8" centerVertically>
                    <LocationIcon size={20} />
                    <Text>{issue.location}</Text>
                </Row>
                <Row gap="8" centerVertically>
                    <WarningIcon size={20} />
                    <Text>{issue.title}</Text>
                </Row>
                <Row gap="8">
                    <SubtitleIcon size={20} />
                    <Text>{issue.description}</Text>
                </Row>
            </Column>
            { photoSources.length > 0 && <ImageCarousel imageSources={photoSources} /> }
            <IssueCompleteButton issue={issue} />
        </Column>
    </Panel>
}

export default IssueDetails;